import React, { useState } from 'react';
import styles from './TopSpendingCategoryModal.module.css';
import Button from './Button';

interface TopSpendingCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete: (category: string) => void;
}

const TopSpendingCategoryModal: React.FC<TopSpendingCategoryModalProps> = ({ 
  isOpen, 
  onClose, 
  onComplete 
}) => {
  const [category, setCategory] = useState<string>('');
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = () => {
    const trimmedCategory = category.trim();
    if (trimmedCategory.length > 0) {
      setShowSuccess(true);
      // Start fireworks animation
      setTimeout(() => {
        onComplete(trimmedCategory);
        setShowSuccess(false);
        setCategory('');
      }, 3000); // Show congratulations for 3 seconds
    }
  };

  const handleClose = () => {
    setCategory('');
    setShowSuccess(false);
    onClose();
  };

  if (showSuccess) {
    return (
      <div className={styles.modalOverlay}>
        <div className={styles.modalContent}>
          <div className={styles.successContainer}>
            <div className={styles.fireworks}>
              <div className={styles.firework}></div>
              <div className={styles.firework}></div>
              <div className={styles.firework}></div>
            </div>
            <h2 className={styles.congratsTitle}>Congratulations!</h2>
            <p className={styles.congratsMessage}>
              You're on your way to financial mastery!
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>What is your top monthly spending category?</h2>
        <div className={styles.inputContainer}>
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            placeholder="e.g. Groceries, Dining, Entertainment..."
            className={styles.categoryInput}
            autoFocus
            maxLength={50}
          />
        </div>
        <div className={styles.buttonContainer}>
          <Button 
            onClick={handleSubmit} 
            disabled={!category.trim()}
            className={styles.doneButton}
          >
            Done
          </Button>
          <Button onClick={handleClose} className={styles.cancelButton}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TopSpendingCategoryModal;